import axios from 'axios';

var getGroup = function getGroup(groupId) {
  return axios.get("/groups/".concat(groupId));
};

var storeGroup = function storeGroup(organizationId, request) {
  return axios.post("/organizations/".concat(organizationId, "/groups"), request);
};

var updateGroup = function updateGroup(groupId, request) {
  return axios.put("/groups/".concat(groupId), request);
};

var getJobs = function getJobs(groupId) {
  return axios.get("/groups/".concat(groupId, "/jobs"));
};

var updateJobs = function updateJobs(groupId, request) {
  return axios.put("groups/".concat(groupId, "/jobs"), request);
};

var getGroupSettings = function getGroupSettings(groupId) {
  return axios.get("groups/".concat(groupId, "/settings"));
};

var updateEmails = function updateEmails(groupId, request) {
  return axios.put("groups/".concat(groupId, "/emails"), request);
};

var removeOrArchiveGroup = function removeOrArchiveGroup(groupId) {
  return axios.delete("groups/".concat(groupId));
};

var unarchive = function unarchive(groupId) {
  return axios.put("groups/".concat(groupId, "/unarchive"));
};

var getGroupRoles = function getGroupRoles() {
  return axios.get("group-roles");
};

export { getGroup, storeGroup, updateGroup, removeOrArchiveGroup, unarchive, getJobs, updateJobs, getGroupSettings, updateEmails, getGroupRoles };